import React, { createContext, useContext, useState } from 'react';

const TOUR_SEEN_KEY = 'ww_tour_seen';

interface TourContextType {
    isTourActive: boolean;
    currentStep: number;
    totalSteps: number;
    startTour(): void;
    nextStep(): void;
    prevStep(): void;
    endTour(): void;
}

const TourContext = createContext<TourContextType>({
    isTourActive: false,
    currentStep: 0,
    totalSteps: 0,
    startTour: () => {},
    nextStep: () => {},
    prevStep: () => {},
    endTour: () => {},
});

const TOTAL_STEPS = 7;

export const TourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isTourActive, setIsTourActive] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);

    const startTour = () => {
        setCurrentStep(0);
        setIsTourActive(true);
    };

    const nextStep = () => {
        setCurrentStep(s => {
            if (s >= TOTAL_STEPS - 1) {
                setIsTourActive(false);
                localStorage.setItem(TOUR_SEEN_KEY, '1');
                return 0;
            }
            return s + 1;
        });
    };

    const prevStep = () => setCurrentStep(s => Math.max(0, s - 1));

    const endTour = () => {
        setIsTourActive(false);
        localStorage.setItem(TOUR_SEEN_KEY, '1');
        setCurrentStep(0);
    };

    return (
        <TourContext.Provider value={{ isTourActive, currentStep, totalSteps: TOTAL_STEPS, startTour, nextStep, prevStep, endTour }}>
            {children}
        </TourContext.Provider>
    );
};

export const useTour = () => useContext(TourContext);
export { TOUR_SEEN_KEY };
export default TourContext;
